export const BASE_SAVES_PATH = "/collector-profile/saves"
